import { RootState } from '@/store/reducers/rootReducer'

export const companySituationSelector = (state: RootState) =>
	state.companySituation
